import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import AppsSection from "../component/section/apps";
import Footer from "../component/layout/footer";
import MemberItemTwo from "../component/items/memberitemtwo";
import PaginaTion from "../component/section/pagination";
import { UserRoleOptions } from "../constants/userRole";
import axios from "axios";
import { SyncLoader } from "react-spinners";

const MembersPage = () => {
  const location = useLocation();

  const [formData, setFormData] = useState({
    lookingFor: "",
    ageStart: "18",
    ageEnd: "30",
    country: "",
  });

  const [profiles, setProfiles] = useState([]);
  const [totalProfiles, setTotalProfiles] = useState(0);


  const getProfiles = async (filters, page = 1) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/profiles?page=${page}`,
        {
          fromAge: filters.ageStart,
          country: filters.country,
          category: filters.lookingFor,
        }
      );

      setProfiles(response.data.data);
      setCurrentPage(response.data.current_page);
      setLastPage(response.data.last_page);
          setTotalProfiles(response.data.total);

    } catch (error) {
      console.error("Failed to fetch profiles:", error);
    } finally {
      setLoading(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (location.state) {
      const newData = {
        lookingFor: location.state.lookingFor || "",
        ageStart: location.state.ageStart || "18",
        ageEnd: location.state.ageEnd || "30",
        country: location.state.city || "",
      };
      setFormData(newData);
      getProfiles(newData, currentPage);
    } else {
      getProfiles(formData, currentPage);
    }
  }, [location.state, currentPage]);

  useEffect(() => {
    fetchCountries();
  }, []);

  const token = localStorage.getItem("token");
  const [countries, setCountries] = useState([]);

  const fetchCountries = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_MAIN_SITE_URL}/user/all-countries`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data?.data?.countries) {
        setCountries(response.data.data.countries);
      }
    } catch (error) {
      console.error("Failed to fetch countries:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    setCurrentPage(1);
    getProfiles(updated, 1);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= lastPage) {
      setCurrentPage(page);
    }
  };

  return (
    <div>
      <Header />
      <PageHeader title={"Members"} />
      <section className="member-page-section">
        <div className="container">
          <div className="member-filter">
            <div className="member-filter-inner">
              <div className="filter-form">
                <div className="person">
                  <div className="custom-select right w-100">
                    <select
                      name="lookingFor"
                      value={formData.lookingFor}
                      onChange={handleChange}
                    >
                      <option value="">Select Favourite</option>
                      {UserRoleOptions.map(({ value, label }) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="age">
                  <div className="right d-flex justify-content-between w-100">
                    <div className="custom-select">
                      <select
                        name="ageStart"
                        value={formData.ageStart}
                        onChange={handleChange}
                      >
                        {[...Array(53)].map((_, i) => {
                          const age = 18 + i;
                          return (
                            <option key={age} value={age}>
                              {age}+
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="city">
                  <div className="custom-select right w-100">
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                    >
                      <option value="">Choose Your Country</option>
                      {countries.map((country) => (
                        <option key={country} value={country}>
                          {country}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="member-wrapper">
            <ul className="member-info mb-4">
              <li className="all-member">
                <p>All Members</p>
                <p>{totalProfiles}</p>
              </li>
            </ul>
            {loading ? (

              <div className="fullscreen-loader">
                <SyncLoader size={12} color="#DF314D" />
              </div>

            ) : (
              <div className="row g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 justify-content-center">
                {profiles.map((profile) => (
                  <MemberItemTwo key={profile.id} data={profile} />
                ))}
              </div>
            )}
            <PaginaTion
              currentPage={currentPage}
              lastPage={lastPage}
              onPageChange={handlePageChange}
            />{" "}
          </div>
        </div>
      </section>
      <AppsSection />
      <Footer />
    </div>
  );
};

export default MembersPage;
